import {register} from 'vue-advanced-chat'
register()
